export default __webpack_public_path__ + "static/media/ECONOMIA E GESTÃO APLICADAS.39e358cb.pdf";